var v1="<div><div ng-if=\"tsdCtrl.course\" class=\"course-name\">{{tsdCtrl.course.club.name}} {{tsdCtrl.course.course.name}}</div><div gnp-time-series-analysis=\"\" score-data=\"tsdCtrl.scoreData\"></div></div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("analysis/time-series-data/time-series-data.jade", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./ngapp/javascript/web/analysis/time-series-data/time-series-data.jade
// module id = 462
// module chunks = 0